import { render, staticRenderFns } from "./DetalhesAnuncio.vue?vue&type=template&id=1c6e92cc&scoped=true"
import script from "./DetalhesAnuncio.vue?vue&type=script&lang=js"
export * from "./DetalhesAnuncio.vue?vue&type=script&lang=js"
import style0 from "./DetalhesAnuncio.vue?vue&type=style&index=0&id=1c6e92cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e92cc",
  null
  
)

export default component.exports